import React from "react";
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";

export default function MetricChart({ title, series, height = 240, color = "#bf5a2a" }) {
  if (!series || series.length === 0) {
    return (
      <div>
        {title && <h3>{title}</h3>}
        <div className="empty">No data for this metric yet.</div>
      </div>
    );
  }
  return (
    <div>
      {title && <h3>{title}</h3>}
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={series} margin={{ top: 8, right: 10, left: -10, bottom: 0 }}>
          <CartesianGrid stroke="#e8e2d8" strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#8a857d" }} minTickGap={24} />
          <YAxis tick={{ fontSize: 11, fill: "#8a857d" }} />
          <Tooltip />
          <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
